import { CALL_QUEUE_ADD, CALL_QUEUE_REMOVE } from './types';

export const CALL_QUEUE_STORAGE_KEY = 'telemed-callback-queue';
export const CALL_QUEUE_MAX_AGE = 24 * 60 * 60 * 1000;

const persist = items => {
  try {
    const persistedItems = items.map(({ refCode, patCode, receivedAt }) => ({ refCode, patCode, receivedAt }));
    window.sessionStorage.setItem(CALL_QUEUE_STORAGE_KEY, JSON.stringify(persistedItems));
  } catch (error) {
    // A full or unavailable sessionStorage must not block consultation work.
  }
};

export const addCallQueue = call => (dispatch, getState) => {
  if (!call?.refCode || !call?.patCode) return;
  const numericReceivedAt = Number(call.receivedAt);
  const parsedReceivedAt = Number.isFinite(numericReceivedAt) ? numericReceivedAt : Date.parse(call.receivedAt);
  const receivedAt = Number.isFinite(parsedReceivedAt) ? parsedReceivedAt : Date.now();
  const current = (getState().callQueue.items || [])
    .filter(item => Number(item.receivedAt) > Date.now() - CALL_QUEUE_MAX_AGE);
  const items = current.some(item => item.refCode === call.refCode)
    ? current
    : [...current, {
      refCode: call.refCode,
      patCode: call.patCode,
      receivedAt,
      patientFirstName: call.patientFirstName,
      patientLastName: call.patientLastName,
      patientMobile: call.patientMobile,
      createByApp: call.createByApp,
      information: call.information
    }]
      .sort((a, b) => a.receivedAt - b.receivedAt);
  persist(items);
  dispatch({ type: CALL_QUEUE_ADD, playload: { items } });
};

export const removeCallQueue = refCode => (dispatch, getState) => {
  const items = (getState().callQueue.items || [])
    .filter(item => Number(item.receivedAt) > Date.now() - CALL_QUEUE_MAX_AGE)
    .filter(item => item.refCode !== refCode);
  persist(items);
  dispatch({ type: CALL_QUEUE_REMOVE, playload: { items } });
};
